import React, { useState } from 'react';
import './CreateEventForm.css';
import supabase from "../../../supabaseClient";

const CreateEventForm = ({
  newEvent,
  setNewEvent,
  handleEventInputChange,
  handleCreateEvent,
  setIsCreatingEvent
}) => {
  const [eventImage, setEventImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setEventImage(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleRemoveImage = () => {
    setEventImage(null);
    setImagePreview(null);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);

    try {
      let event_banner_url = null;

      if (eventImage) {
        const fileExt = eventImage.name.split('.').pop();
        const fileName = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}.${fileExt}`;
        const filePath = `event-avatars/${fileName}`;

        const { error: uploadError } = await supabase.storage
          .from('event-avatars')
          .upload(filePath, eventImage);

        if (uploadError) {
          throw uploadError;
        }

        const { data: { publicUrl } } = supabase.storage
          .from('event-avatars')
          .getPublicUrl(filePath);

        event_banner_url = publicUrl;
      }

      setNewEvent(prev => ({ ...prev, event_banner_url }));
      await handleCreateEvent();
      setEventImage(null);
      setImagePreview(null);
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('Error uploading image. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="create-event-form-container">
      <form className="create-event-form" onSubmit={onSubmit}>
        <h2>Create New Event</h2>
        <label>
          Title
          <input
            type="text"
            name="title"
            value={newEvent.title}
            onChange={handleEventInputChange}
            required
            maxLength={80}
          />
        </label>
        <label>
          Date
          <input
            type="date"
            name="date"
            value={newEvent.date}
            onChange={handleEventInputChange}
            required
            min={new Date().toISOString().split('T')[0]}
          />
        </label>
        <label>
          Time
          <input
            type="time"
            name="time"
            value={newEvent.time}
            onChange={handleEventInputChange}
            required
          />
        </label>
        <label>
          Language
          <select
            name="language"
            value={newEvent.language}
            onChange={handleEventInputChange}
            required
          >
            <option value="">Select Language</option>
            <option value="English">English</option>
            <option value="Spanish">Spanish</option>
            <option value="French">French</option>
            <option value="German">German</option>
            <option value="Chinese">Chinese</option>
            <option value="Japanese">Japanese</option>
          </select>
        </label>
        <div className="event-image-upload">
          <label>
            Event Image
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ display: 'none' }}
            />
            <div 
              className={`image-upload-area ${imagePreview ? 'has-image' : ''}`}
              onClick={() => !imagePreview && document.querySelector('input[type="file"]').click()}
            >
              {imagePreview ? (
                <div className="image-preview-container">
                  <img src={imagePreview} alt="Event preview" />
                  <button 
                    type="button" 
                    className="remove-image-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveImage();
                    }}
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <div className="upload-placeholder">
                  <span>Click to upload event image</span>
                  <small>(Optional)</small>
                </div>
              )}
            </div>
          </label>
        </div>

        <label>
          Description
          <textarea
            name="description"
            value={newEvent.description}
            onChange={handleEventInputChange}
            required
            rows={4}
            maxLength={300}
            placeholder="Describe your event..."
          />
        </label>
        <div className="event-form-actions">
          <button
            type="button"
            className="cancel-btn"
            onClick={() => setIsCreatingEvent(false)}
          >
            Cancel
          </button>
          <button type="submit" className="create-btn">
            Create Event
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateEventForm;